<div class="header" [style.border-bottom]="border">
    <div class="container-fluid">
        <div class="row">
            <div class="temp">
                <img src="assets/images/icons/left alignment.svg" *ngIf="showIcon !==false" alt="Left Alignment icon"
                    (click)="expand()">
                <img src="assets/images/icons/header-icon.svg" alt="Header icon" [routerLink]="['/']">
            </div>
        </div>
    </div>
</div>